/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Event } from "../models/Event";
import type {
  ChangePasswordRequest,
  EmailNotificationRequest,
  EventInput,
  InviteMembersRequest,
  PaymentPro,
  TicketPurchasePayload,
  UpdateSettingsResponse,
} from "../models/EventInput";
import type { EventSummary } from "../models/EventSummary";
import type { CancelablePromise } from "../../core/CancelablePromise";
import { OpenAPI, OpenCecureEventAPI } from "../../core/OpenAPI";
import { request as __request } from "../../core/request";
export class EventsService {
  /**
   * List events
   * Retrieves a list of events with optional filtering
   * @param category Filter by event category
   * @param from Filter events from date (ISO format)
   * @param to Filter events to date (ISO format)
   * @param isVirtual Filter by virtual event status
   * @param eventType Filter by event type
   * @param maxPrice Maximum price filter
   * @param search Search term for event title or description
   * @param status Filter by event status
   * @param page Page number for pagination
   * @param limit Number of events per page
   * @returns any A list of events
   * @throws ApiError
   */
  public static getEvents(
    token: string,
    category?: string,
    from?: string,
    to?: string,
    isVirtual?: boolean,
    eventType?:
      | "in-person"
      | "virtual"
      | "hybrid"
      | "webinar"
      | "conference"
      | "workshop",
    maxPrice?: number,
    search?: string,
    status?: "draft" | "published" | "cancelled" | "completed",
    page: number = 1,
    limit: number = 10
  ): CancelablePromise<{
    events?: Array<EventSummary>;
    total?: number;
    page?: number;
    totalPages?: number;
  }> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/event/v1/list-events",
      headers: {
        Authorization: token,
      },
      query: {
        category: category,
        from: from,
        to: to,
        isVirtual: isVirtual,
        eventType: eventType,
        maxPrice: maxPrice,
        search: search,
        status: status,
        page: page,
        limit: limit,
      },
      errors: {
        400: `Invalid query parameters`,
      },
    });
  }
  /**
   * Create a new event
   * Creates a new event
   * @param requestBody
   * @returns Event Event created successfully
   * @throws ApiError
   */

  //   public static postEvents(
  //     token: string,
  //     requestBody: EventInput
  //   ): CancelablePromise<Event> {
  //     return __request(OpenAPI, {
  //       method: "POST",
  //       url: "/event/v1/event",
  //       body: requestBody,
  //       mediaType: "application/json",
  //       headers: {
  //         Authorization: token,
  //       },
  //       errors: {
  //         400: `Invalid input`,
  //         401: `Unauthorized`,
  //         403: `Insufficient permissions`,
  //       },
  //     });
  //   }

  public static postEvents(
    requestBody: EventInput,
    token: string
  ): CancelablePromise<Event> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/event/v1/event",
      body: requestBody,
      headers: {
        Authorization: token,
      },
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Insufficient permissions`,
      },
    });
  }
  /**
   * Get event details
   * Retrieves detailed information about a specific event
   * @param eventId ID of the event to retrieve
   * @returns Event Detailed event information
   * @throws ApiError
   */
  public static getEvents1(
    eventId: string,
    token: string
  ): CancelablePromise<Event> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/event/v1/event/{eventId}",
      headers: {
        Authorization: token,
      },
      path: {
        eventId: eventId,
      },
      errors: {
        404: `Event not found`,
      },
    });
  }
  /**
   * Update an event
   * Updates an existing event
   * @param eventId ID of the event to update
   * @param requestBody
   * @returns Event Event updated successfully
   * @throws ApiError
   */
  public static putEvents(
    token: string,
    eventId: string,
    requestBody: EventInput
  ): CancelablePromise<Event> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/event/v1/event/{eventId}",
      path: {
        eventId: eventId,
      },
      headers: {
        Authorization: token,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Insufficient permissions`,
        404: `Event not found`,
      },
    });
  }
  /**
   * Delete an event
   * Deletes an existing event
   * @param eventId ID of the event to delete
   * @returns void
   * @throws ApiError
   */
  public static deleteEvents(eventId: string): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/events/{eventId}",
      path: {
        eventId: eventId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Insufficient permissions`,
        404: `Event not found`,
      },
    });
  }

  public static postMembers(
    token: string,
    requestBody: InviteMembersRequest
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/core/v1/invite-team-member",
      headers: {
        Authorization: token,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Insufficient permissions`,
        404: `Event not found`,
      },
    });
  }

  public static changePassword(
    token: string,
    requestBody: ChangePasswordRequest
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/open/v1/Change-password",
      headers: {
        Authorization: token,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Insufficient permissions`,
        404: `Event not found`,
      },
    });
  }

  public static emailNotification(
    token: string,
    requestBody: EmailNotificationRequest
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/core/v1/email-notification",
      headers: {
        Authorization: token,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Insufficient permissions`,
        404: `Event not found`,
      },
    });
  }

  public static userSettings(
    token: string,
    requestBody: UpdateSettingsResponse
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/core/v1/update_settings",
      headers: {
        Authorization: token,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Insufficient permissions`,
        404: `Event not found`,
      },
    });
  }

  public static exploreEvent(): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/open/v1/explore-events",

      errors: {
        404: `Event not found`,
      },
    });
  }

  public static exploreSingleEvent(id: string): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/event/v1/event_one/" + id,

      errors: {
        404: `Event not found`,
      },
    });
  }

  public static registerPaidEvent(
    requestBody: TicketPurchasePayload
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/core/v1/register",
      body: requestBody,
      headers: {
        "x-api-key": "x2cW1pjKw3jy",
      },

      errors: {
        404: `Event not found`,
      },
    });
  }

  public static subscriptionType(token: string): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/core/v1/subscription-type",
      headers: {
        Authorization: token,
      },
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Insufficient permissions`,
        404: `Event not found`,
      },
    });
  }

  public static createPayoutAccount(token: string): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/core/v1/create-payout",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Insufficient permissions`,
        404: `Event not found`,
      },
    });
  }

  public static updatePayoutAccount(token: string, payload:{
    business_profile: {
      name: string
    }
  }  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/core/v1/update-account",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: payload,
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Insufficient permissions`,
        404: `Event not found`,
      },
    });
  }

  public static getPayoutAccount(token: string): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/core/v1/get-account",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Insufficient permissions`,
        404: `Event not found`,
      },
    });
  }

  public static paymentPro(
    token: string,
    requestBody: PaymentPro
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/core/v1/payment-pro",
      headers: {
        Authorization: token,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Insufficient permissions`,
        404: `Event not found`,
      },
    });
  }

  public static registerPro(
    token: string,
    requestBody: PaymentPro
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/core/v1/register-pro",
      headers: {
        Authorization: token,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Insufficient permissions`,
        404: `Event not found`,
      },
    });
  }
  public static createMeeting(requestBody: {
    event_name: string;
    email: string;
    start_time: string;
    end_time: string;
    event_date: string;
    timezone?: string;
    attendees: string[];
    description?: string;
  }): CancelablePromise<void> {
    return __request(OpenCecureEventAPI, {
      method: "POST",
      url: "/meeting/v1/cecurestream-meeting",
      body: requestBody,
      headers: {
        "x-api-key": import.meta.env.VITE_CECURESTREAM_MEETING_KEY,
      },
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Forbidden`,
        500: `Server error`,
      },
    });
  }

  public static viewEvent(
    eventId: string,
    token: string
  ): CancelablePromise<Event> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/event/v1/view-event/{eventId}",
      headers: {
        Authorization: token,
      },
      path: {
        eventId: eventId,
      },
      errors: {
        404: `Event not found`,
      },
    });
  }

  public static listCurrentAttendees(
    eventId: string,
    token: string
  ): CancelablePromise<Event> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/core/v1/list-current-attendee/{eventId}",
      headers: {
        Authorization: token,
      },
      path: {
        eventId: eventId,
      },
      errors: {
        404: `Event not found`,
      },
    });
  }
  public static listDashboardAttendees(
    eventId: string,
    token: string
  ): CancelablePromise<Event> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/core/v1/list-attendees/{eventId}",
      headers: {
        Authorization: token,
      },
      path: {
        eventId: eventId,
      },
      errors: {
        404: `Event not found`,
      },
    });
  }

  public static exportAttendees(
    eventId: string,
    token: string
  ): CancelablePromise<Event> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/core/v1/export-attendees/{eventId}",
      headers: {
        Authorization: token,
      },
      path: {
        eventId: eventId,
      },
      errors: {
        404: `Event not found`,
      },
    });
  }

  public static sendEmailApi(
    requestBody: {
      event_id: string;
      attendee_ids: string[];
      // subject: string;
      email_body: string;
    },
    token: string
  ): CancelablePromise<Event> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/core/v1/export_email",
      body: requestBody,
      headers: {
        Authorization: token,
      },
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        401: `Unauthorized`,
        403: `Insufficient permissions`,
      },
    });
  }
}
